<div class="top-bar-menu">
  @for (link of topBarLinksItems(); track link) {
    @if (isDropDown(link)) {
      <div ngbDropdown class="d-inline-block">
        <a id="dropdownBasic" class="nav-link" ngbDropdownToggle translate>
          @if (link.link_icon.length) {
            <span class="icon {{ link.link_icon }}"></span>
          }
          <span translate>{{ link.link_name }}</span>
        </a>
        @if (link.sub_items.length) {
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            @for (sub_item of link.sub_items; track sub_item) {
              <a
                class="dropdown-item text-start"
                [href]="sub_item.link_url"
                (click)="itemClicked.emit()"
              >
                @if (sub_item.link_icon.length) {
                  <span class="icon {{ sub_item.link_icon }}"></span>
                }
                {{ sub_item.link_name }}
              </a>
            }
          </div>
        }
      </div>
    } @else {
      <a [href]="link.link_url" class="link" (click)="itemClicked.emit()">
        @if (link.link_icon.length) {
          <span class="icon {{ link.link_icon }}"></span>
        }
        <span translate>{{ link.link_name }}</span>
      </a>
    }
  }
</div>
